export const selectDevotionalList = (state) => state.devotionallist;
